import { type IconProps } from "./Icon.props";

const DEFAULT_SIZE = "element.lg";

export default function validateKeys(
  props: IconProps
): Record<string, unknown> {
  const {
    outline: _outline,
    colorPalette: _colorPalette,
    primary: _primary,
    secondary: _secondary,
    // Strip css/sx to prevent overriding the icon's two-tone CSS styles from createWebIcon
    css: _css,
    sx: _sx,
    boxSize,
    w,
    h,
    ...rest
  } = props;

  // Chakra Icon only respects boxSize, not h/w
  // Prioritize boxSize if provided, otherwise use h/w for backward compat
  const effectiveSize = boxSize ?? h ?? w ?? DEFAULT_SIZE;

  return {
    boxSize: effectiveSize,
    ...rest,
  };
}
